<template>
  <div class="container-full">
    <div class="top-header">
      <backDashboard />
      <headerTitle :moduleDetails="section" />
      <userLogout />
    </div>
    <div class="site-content">
      <menuSidebar />
      <div class="main-content pt-4">
        <div class="main-title align-items-center">
          <h3>Milestone Date<span class="text-lowercase">(s)</span></h3>

          <!-- Modules dropdown Start -->
          <div class="main-searchForms">
            <div class="search-dropdown" v-if="modules_all.length > 1">
              <button
                class="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenu1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ ModuleSelectedName }}
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                <a
                  class="dropdown-item"
                  type="button"
                  @click="toggleSort(sortColumn, sortOrder, '')"
                ></a>
                <a
                  v-for="(mods, index) in modules_all"
                  :key="index"
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedModules(index)"
                  >{{ mods.attributes.name }}</a
                >
              </div>
            </div>
          </div>

          <!-- Modules dropdown End -->
        </div>
        <div class="data-table column-7 milestone-dates-table">
          <div class="data-head">
            <div class="data-col">Learning object</div>
            <div class="data-col">Release hold date</div>
            <div class="data-col">Hold note</div>
            <div class="data-col" v-if="!isBasicInstructor">Action</div>
          </div>
          <div class="data-content">
            <!-- data row repeat here -->
            <VeeForm ref="form">
              <span v-if="milestone_dates.length > 0">
                <span
                  v-for="(milestone, index) in milestone_dates"
                  :key="milestone._uid"
                >
                  <div v-if="!milestone.attributes._destroy" class="data-row">
                    <div class="data-col">
                      <span class="form-data">
                        <div class="data-dropdown">
                          <button
                            :class="[
                              'btn btn-secondary dropdown-toggle',
                              isActive &&
                              !milestone.attributes.learning_object_id
                                ? 'form-invalid'
                                : '',
                            ]"
                            type="button"
                            id="dropdownMenu2"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            :disabled="isBasicInstructor"
                          >
                            <div class="select-value text-truncate">
                              <div
                                v-if="milestone.attributes.learning_object_id"
                              >
                                <div
                                  v-for="lo in loDatas"
                                  :key="lo.id"
                                  @click="
                                    setLo(
                                      lo.attributes.learning_object_id,
                                      index
                                    )
                                  "
                                >
                                  <div
                                    v-if="
                                      parseInt(
                                        milestone.attributes.learning_object_id
                                      ) ==
                                      parseInt(lo.attributes.learning_object_id)
                                    "
                                    class="text-truncate"
                                  >
                                    {{ lo.attributes.card_order }}:
                                    {{ lo.attributes.name }}
                                  </div>
                                </div>
                              </div>
                              <div v-else class="data-dropdown-placeholder">
                                Select Learning Object
                              </div>
                            </div>
                          </button>
                          <div
                            class="dropdown-menu dropdown-scroll"
                            aria-labelledby="dropdownMenu2"
                          >
                            <button
                              class="dropdown-item"
                              type="button"
                              v-for="lo in loDatas"
                              :key="lo.id"
                              :disabled="
                                isLoUsedElsewhere(
                                  lo.attributes.learning_object_id,
                                  index
                                )
                              "
                              @click="
                                setLo(lo.attributes.learning_object_id, index)
                              "
                            >
                              {{ lo.attributes.card_order }}:
                              {{ lo.attributes.name }}
                            </button>
                          </div>
                          <span
                            :class="[
                              isActive &&
                              !milestone.attributes.learning_object_id
                                ? 'invalid'
                                : '',
                            ]"
                            :style="[
                              isActive &&
                              !milestone.attributes.learning_object_id
                                ? { display: 'block' }
                                : { display: 'none' },
                            ]"
                            >Mandatory</span
                          >
                        </div>
                      </span>
                    </div>
                    
                    
                   
                    <div class="data-col">
                      <VeeField
                        class="form-data"
                        v-if="milestone.attributes.hold_on_complete"
                        :name="'Date-' + milestone._uid"
                        rules="required"
                        v-model="milestone.attributes.release_hold_date"
                        v-slot="{ field, errors }"
                      >
                        <div
                          :class="[
                            'data-calender',
                            isActive && errors[0] ? 'form-invalid' : '',
                          ]"
                        >
                          <VDatePicker
                            mode="dateTime"
                            v-model="milestone.attributes.release_hold_date"
                            :is24hr="false"
                          >
                            <template #default="{ inputValue, togglePopover }">
                              <input
                                v-bind="field"
                                class="form-control"
                                :value="inputValue"
                                @click="!isBasicInstructor && togglePopover()"
                                :disabled="isBasicInstructor"
                                placeholder="Select date &amp; time"
                                readonly
                              />
                            </template>
                          </VDatePicker>
                        </div>
                        <span
                          :class="[isActive ? 'invalid' : '']"
                          :style="[
                            isActive
                              ? { display: 'block' }
                              : { display: 'none' },
                          ]"
                          v-if="errors[0]"
                          >Mandatory</span
                        >
                      </VeeField>
                      
                    </div>
                    <div class="data-col">
                      <input
                        type="text"
                        class="form-control hold-note-input"
                        maxlength="500"
                        placeholder="Add a hold message"
                        v-model="milestone.attributes.hold_note"
                        :disabled="isBasicInstructor"
                      />
                    </div>
                    <div class="data-col" v-if="!isBasicInstructor">
                      <div class="data-trash">
                        <a>
                          <em
                            class="icon-trash"
                            @click="deleteLo(milestone)"
                          ></em>
                        </a>
                      </div>
                      <div
                        class="data-trash"
                        v-if="milestone.attributes.isSave"
                      ></div>
                    </div>
                  </div>
                </span>
              </span>
              <div class="data-row" v-if="!isBasicInstructor">
                <div class="data-col">
                  <button @click="AddLo()" class="btn primary w-100">
                    + Learning Object
                  </button>
                </div>
              </div>
            </VeeForm>
          </div>
        </div>
        <div class="main-title button-right">
          <button
            type="button"
            class="btn primary save-btn"
            @click="saveData()"
            v-if="!isBasicInstructor"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <delete-milestone-modal />
</template>
<script>
import userLogout from "../components/userLogout.vue";
import backDashboard from "../components/backDashboard.vue";
import menuSidebar from "../components/menuSidebar.vue";
import headerTitle from "../components/headerTitle.vue";
import api from "../services/api";
import { utilFunctionService } from "@/utils/utils.service";
import { commonConfig } from "@/utils/commonConfig";
import deleteMilestoneModal from "../components/modals/deleteMilestoneModal.vue";
import moment from "moment";

export default {
  name: "manageRubric",
  components: {
    backDashboard,
    userLogout,
    menuSidebar,
    headerTitle,
    deleteMilestoneModal,
  },
  data() {
    return {
      ModuleSelectedName: "",
      modules_all: [],
      loDatas: [],
      modules: {},
      section: {},
      milestone_dates: [],
      isActive: "",
      date: "",
      isBasicInstructor: false,
      search_learner: "",
      sortOrder: "asc",
      sortColumn: "name",
      lo_index: "",
      page: 1,
      uidSeq: 0,
    };
  },
  methods: {
    getSelectedModules(index) {
      this.milestone_dates = [];
      api
        .getLOList(this.section.id, this.modules_all[index].id)
        .then((res) => {
          this.loDatas = res.data.lo_list;
          // console.log(this.loDatas, "*** this.loDatas");
          this.getMilestones(this.section.id, this.modules_all[index].id);
        })
        .catch(() => {});
      this.ModuleSelectedName = this.modules_all[index].attributes.name;
    },
    getMultiELMList() {
      api
        .getMultiELMList(this.section.id)
        .then((res) => {
          this.modules_all = res.data.data.attributes.learn_mods;
          this.ModuleSelectedName = this.modules_all[0].attributes.name;
        })
        .catch(() => {});
    },
    setInstructorPermissions() {
      this.instructorInfo = JSON.parse(
        localStorage.getItem("instructor")
      ).users;
      let role = this.instructorInfo.attributes.user_roles[0];
      if (role == "instructor_basic") {
        this.isBasicInstructor = true;
      }
    },
    getLoListData() {
      this.section = JSON.parse(localStorage.getItem("section"));

      // Get Section Information
      api
        .getLearnerDetails(
          this.section.id,
          this.page,
          this.search_learner,
          this.sortColumn,
          this.sortOrder,
          this.lo_index
        )
        .then((res) => {
          this.section_details = res.data.section;
          api
            .getLOList(
              this.section.id,
              this.section_details.attributes.learn_mods[0].id
            )
            .then((res) => {
              this.loDatas = res.data.lo_list;
              // console.log(this.loDatas, "*** this.loDatas");
              this.getMilestones(
                this.section.id,
                this.section_details.attributes.learn_mods[0].id
              );
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    getMilestones(id, elm_id) {
      utilFunctionService.showLoader();
      api
        .getMilestones(id, elm_id)
        .then((res) => {
          if (res.data && res.data.data) {
            if (res.data.data.length > 0) {
              this.milestone_dates = [];
              this.milestone_dates = res.data.data;
              this.milestone_dates.forEach((milestone) => {
                milestone._uid = ++this.uidSeq;
                milestone.attributes._destroy = false;
                milestone.attributes.release_hold_date = milestone.attributes
                  .release_hold_date
                  ? moment(milestone.attributes.release_hold_date).format()
                  : "";
                milestone.attributes.completed_by = milestone.attributes
                  .completed_by
                  ? moment(milestone.attributes.completed_by).format()
                  : "";
              });
            } else {
              this.AddLo();
            }
          }
          utilFunctionService.hideLoader();
        })
        .catch(() => {
          utilFunctionService.hideLoader();
        });
    },
    deleteLo(milestone) {
      this.$modal.show('deleteMilestoneModal', {
        onConfirm: () => {
          // An unsaved row (no id) only exists client-side: just drop it.
          if (!milestone.id) {
            this.removeMilestoneFromList(milestone);
            return;
          }
          utilFunctionService.showLoader();
          api
            .deleteMilestones(this.section.id, milestone.id)
            .then(() => {
              this.removeMilestoneFromList(milestone);
              utilFunctionService.showSuccess(
                commonConfig.appMessages.deleteRecord
              );
              utilFunctionService.hideLoader();
            })
            .catch(() => {
              utilFunctionService.hideLoader();
            });
        }
      });
    },
    removeMilestoneFromList(milestone) {
      // Resolve the live index at call time: the list may have changed while
      // the modal/request was in flight, so a captured index could be stale.
      const currentIndex = this.milestone_dates.indexOf(milestone);
      if (currentIndex !== -1) {
        this.milestone_dates.splice(currentIndex, 1);
      }
    },
    AddLo() {
      this.isActive = false;
      this.milestone_dates.push({
        id: "",
        _uid: ++this.uidSeq,
        type: "section_milestone",
        attributes: {
          section_id: "",
          learning_object_id: "",
          hold_note: "",
          hold_on_complete: true,
          warning_email_days: "",
          completed_by: "",
          release_hold_date: "",
          isSave: true,
        },
      });
    },
    saveData() {
      if (this.milestone_dates.length > 0) {
        this.$refs.form.validate().then(({ valid: success }) => {
          this.isActive = true;
          if (!success) {
            return;
          } else {
            const selectedLoIds = this.milestone_dates.map((milestone) =>
              parseInt(milestone.attributes.learning_object_id)
            );
            if (new Set(selectedLoIds).size !== selectedLoIds.length) {
              utilFunctionService.showerr(commonConfig.appMessages.sameLoRecord);
              return;
            }
            utilFunctionService.showLoader();
            let fData = new FormData();
            this.milestone_dates.forEach((milestone) => {
              fData.append(
                "section[section_milestones_attributes][][id]",
                milestone.id || ""
              );
              fData.append(
                "section[section_milestones_attributes][][learning_object_id]",
                milestone.attributes.learning_object_id
              );
              fData.append(
                "section[section_milestones_attributes][][hold_note]",
                milestone.attributes.hold_note
              );
              fData.append(
                "section[section_milestones_attributes][][hold_on_complete]",
                milestone.attributes.hold_on_complete
              );
              if (!milestone.attributes.hold_on_complete) {
                milestone.attributes.release_hold_date = "";
              }
              fData.append(
                "section[section_milestones_attributes][][release_hold_date]",
                milestone.attributes.hold_on_complete
                  ? moment(milestone.attributes.release_hold_date).format("LLL")
                  : ""
              );
              fData.append(
                "section[section_milestones_attributes][][_destroy]",
                milestone.attributes._destroy ? true : false
              );
            });
            api
              .saveMilestones(this.section.id, fData)
              .then(() => {
                utilFunctionService.showSuccess(
                  commonConfig.appMessages.saveRecord
                );
                utilFunctionService.hideLoader();
                this.getMilestones(
                  this.section.id,
                  this.section.attributes.learn_mods[0].id
                );
              })
              .catch(() => {
                utilFunctionService.hideLoader();
              });
          }
        });
      } else {
        utilFunctionService.showLoader();
        utilFunctionService.showerr(commonConfig.appMessages.addLoRecord);
        utilFunctionService.hideLoader();
      }
    },
    setLo(id, index) {
      this.milestone_dates[index].attributes.learning_object_id = id;
    },
    isLoUsedElsewhere(loId, currentIndex) {
      return this.milestone_dates.some(
        (milestone, index) =>
          index !== currentIndex &&
          parseInt(milestone.attributes.learning_object_id) === parseInt(loId)
      );
    },
  },
  created() {
    this.section = JSON.parse(localStorage.getItem("section"));
    this.module = this.section;
    let dateVal = new Date();
    this.date = moment(dateVal).format();
    this.getLoListData();
    this.setInstructorPermissions();
    this.getMultiELMList();
    this.getMilestones(this.section.id, this.section.attributes.learn_mods[0].id);
  }
};
</script>


<style lang="scss">
@import "../styles/variables.scss";
@import "../styles/mixin.scss";

.button-right {
  float: right;
}

// Scoped polish for the Milestone Dates table only. These overrides are
// nested under .milestone-dates-table so they cannot leak into other views
// that share the generic .data-table / .data-row classes.
.milestone-dates-table {
  // Four real columns: learning object, release date, hold note, action.
  // Overrides the shared column-7 widths which assumed a different layout.
  .data-head .data-col,
  .data-row .data-col {
    &:nth-child(1) {
      width: 30%;
    }
    &:nth-child(2) {
      width: 27%;
    }
    &:nth-child(3) {
      width: 35%;
    }
    &:nth-child(4) {
      width: 8%;
      text-align: center;
    }
  }

  .data-content .data-row {
    margin-bottom: 12px;
  }

  .data-row {
    align-items: center;

    // Give every input card a visible, consistent border and a shared 49px
    // height so the columns line up exactly — the dropdown .btn, the date
    // card, and the note input otherwise use different intrinsic sizing.
    .data-dropdown .btn,
    .data-calender,
    .hold-note-input {
      box-sizing: border-box;
      height: 49px;
      border: 1px solid $border-color;
      border-radius: 6px;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;

      &:hover {
        border-color: #d2d2d2;
      }
    }

    .data-dropdown .btn:focus,
    .data-calender:focus-within,
    .hold-note-input:focus {
      border-color: $primary-button-color;
      box-shadow: 0 0 0 2px rgba(61, 188, 158, 0.15);
      outline: 0;
    }

    .data-calender {
      display: flex;
      align-items: center;
      margin: 0;
    }

    .hold-note-input {
      width: 100%;
      padding: 6px 15px;
      font-size: 14px;
      color: $theme-color;

      &::placeholder {
        color: #aab7b3;
      }
    }

    .data-trash {
      opacity: 0.55;
      transition: opacity 0.15s ease;

      a {
        cursor: pointer;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
